import React from "react";

// Define props interface
interface RegisterBoxProps {
  headerText: string;
  paragraphText: string;
  backgroundColor?: string; // Make backgroundColor optional
  textColor?: string; // Make textColor optional
  isMobile: boolean;
  children?: React.ReactNode;
}

const RegisterBox: React.FC<RegisterBoxProps> = ({
  headerText,
  paragraphText,
  backgroundColor = "",
  textColor = "#fff",
  isMobile,
  children,
}) => {
  return (
    <div className="flex flex-col items-center bg-highlight w-full mx-auto my-5 p-16 ">
      <div className="w-full rounded flex flex-col md:flex-row justify-between items-center h-auto">
        {/* Header Section */}
        <div className=" mb-7 md:mb-0 w-auto md:w-1/3 flex items-center justify-center">
          <h2
            className="text-xl text-white font-bold w-full h-full"
            style={{ color: textColor }}
          >
            {headerText}
          </h2>
        </div>
        {/* Text Section */}
        <div className="w-full flex items-center ">
          <p className="text-center md:text-left  md:leading-relaxed text-gray-200">
            {paragraphText}
          </p>
        </div>
      </div>
      {children && <div className="mt-10">{children}</div>}
    </div>
  );
};

export default RegisterBox;
